export const ADD_KEY: string = "ADD_KEY";
export const CHECK_KEY: string = "CHECK_KEY";
export const ADD_SID: string = "ADD_SID";

export function addKey(key: string): IAddKeyActionType {
    return { type: ADD_KEY, key: key};
}
export function checkKey(doesExist: boolean): IcheckKeyActionType {
    return { type: CHECK_KEY, doesExist: doesExist};
}
export function addSID(sid: string): IAddSIDActionType {
    return { type: ADD_SID, sid: sid};
}

export interface IAddKeyActionType { 
    type:string, 
    key: string
}

export interface IcheckKeyActionType { 
    type:string, 
    doesExist: boolean
}

export interface IAddSIDActionType { 
    type:string, 
    sid: string
}